import styled from "styled-components";

export const PopupWrapper = styled.div`
  .popup-main.popup-main {
    max-width: 584px;
  }
  .footer {
    padding-left: 20px;
  }
`;

export const HeaderPopupStyle = styled.div`
  text-align: center;
  font-weight: bold;
  font-size: 28px;
  padding: 20px 0 8px 0;
  @media (max-width: 900px) {
    font-size: 20px;
  }
`;

export const SubTitlePopup = styled.div`
  text-align: center;
  font-size: 16px;
  padding-bottom: 32px;

`;

export const PopupContentStyle = styled.div`
  text-align: center;
  .shape-filed {
    padding-bottom: 24px;
    display: flex;
    justify-content: center;
  }
  .input-field {
    height: 49px;
    border-radius: 8px;
    border: var(--glz-color-neutral-tone-1);
    background: var(--glz-color-neutral-tone-1);
  }
  .glz-input input:-webkit-autofill {
    box-shadow: none;
  }
  .glz-input.glz-is-error {
    border: 1px solid var(--glz-color-error);
  }
  .label {
    > :first-child {
      display: flex;
    }
  }
`;

export const FooterWrapper = styled.div`
  .footer {
    padding-left: 20px;
  }
  .glz-popup-footer {
    margin-top: 0px;
    @media (max-width: 900px) {
      justify-content: center;
      padding-left: 0px;
      border-radius: 10px
    }
  }
`;
